const config = {
    REACT_APP_AUTH0_DOMAIN: window.REACT_APP_AUTH0_DOMAIN,
    REACT_APP_AUTH0_CLIENT_ID: window.REACT_APP_AUTH0_CLIENT_ID
  };
  
export default config;